import { useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import { trackEvent } from "@/lib/api";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function Framework() {
  const { t } = useLang();
  useEffect(() => { trackEvent("framework_started", { tool: "framework_page" }); }, []);

  const stages = [
    { key: 1, title: t.framework.s1_title, cats: t.framework.s1_cats },
    { key: 2, title: t.framework.s2_title, cats: t.framework.s2_cats },
    { key: 3, title: t.framework.s3_title, cats: t.framework.s3_cats },
    { key: 4, title: t.framework.s4_title, cats: t.framework.s4_cats },
  ];

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20" data-testid="framework-page">
      <h1 className="text-4xl sm:text-5xl font-bold">{t.framework.title}</h1>
      <p className="mt-4 text-slate-300 max-w-3xl">{t.framework.sub}</p>
      <p className="mt-3 text-sm text-slate-500 max-w-3xl italic">{t.framework.framing}</p>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {stages.map((s) => (
          <div key={s.key} className="card-mift p-6" data-testid={`stage-${s.key}`}>
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full stage-badge flex items-center justify-center font-semibold">
                {String(s.key).padStart(2, "0")}
              </div>
              <div className="text-xs uppercase tracking-widest text-slate-400">Stage</div>
            </div>
            <h3 className="mt-4 font-semibold text-slate-100 leading-snug">{s.title}</h3>
            <div className="mt-4 text-xs uppercase tracking-wider text-blue-300">{t.framework.cats_title}</div>
            <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-sm text-slate-300">
              {s.cats.map((c, i) => (
                <li key={i} className="flex items-start gap-2">
                  <CheckCircle2 className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                  <span>{c}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-14 flex flex-wrap gap-3">
        <Link to="/assessment" className="btn-primary">{t.cta.use_assessment}</Link>
        <Link to="/mediation" className="btn-ghost">{t.nav.mediation}</Link>
        <Link to="/agreement" className="btn-ghost">{t.nav.agreement}</Link>
      </div>
    </div>
  );
}
